import React, { createContext, ReactNode } from 'react';

import { SizeMe } from 'react-sizeme';

/**
 * Контекст для предоставления ширины корневого контейнера его потомкам.
 * @type {React.Context<number | null>}
 */

export const RootWidthContext = createContext<number | null>(null);

const DESKTOP_WIDTH_DEFAULT = 1024;

interface RootWidthContextProviderProps {
  children: ReactNode | ReactNode[];
  page?: string;
}

/**
 * Компонент-провайдер для RootWidthContext, который использует `react-sizeme` для измерения ширины корневого контейнера.
 *
 * @param {RootWidthContextProviderProps} props - Свойства компонента RootWidthContextProvider.
 * @param {React.ReactNode | React.ReactNode[]} props.children - Дочерние элементы, которые будут отображены внутри провайдера.
 * @returns {JSX.Element} - Отображённый компонент RootWidthContextProvider, который предоставляет контекст ширины корневого контейнера.
 */

export const RootWidthContextProvider = ({
  children,
  page,
}: RootWidthContextProviderProps) => {
  if (page === 'sideMenu') {
    return (
      <RootWidthContext.Provider value={DESKTOP_WIDTH_DEFAULT}>
        {children}
      </RootWidthContext.Provider>
    );
  }

  if (page === 'header') {
    return (
      <div style={{ width: '100%' }}>
        <RootWidthContext.Provider value={DESKTOP_WIDTH_DEFAULT}>
          {children}
        </RootWidthContext.Provider>
      </div>
    );
  }

  return (
    <SizeMe>
      {({ size }) => (
        <div id="sizeme" style={{ width: '100%' }}>
          <div
            style={
              {
                containerType: 'inline-size',
                width: size.width,
              } as Record<string, string | number>
            }
          >
            <RootWidthContext.Provider value={size.width}>
              {children}
            </RootWidthContext.Provider>
          </div>
        </div>
      )}
    </SizeMe>
  );
};
